import { render, staticRenderFns } from "./account_balance.vue?vue&type=template&id=7f22f400&scoped=true&"
import script from "./account_balance.vue?vue&type=script&lang=js&"
export * from "./account_balance.vue?vue&type=script&lang=js&"
import style0 from "./account_balance.vue?vue&type=style&index=0&id=7f22f400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22f400",
  null
  
)

export default component.exports